// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================= */
/* CARD COMPONENT STYLES - VANTA INSPIRED      */
/* ============================================= */

.card {
  background-color: white;
  border: 1px solid #E2E8F0;
  border-radius: 0.875rem;
  overflow: hidden;
  transition: all 200ms ease-in-out;
  position: relative;
}

.dark .card {
  background-color: #1E293B;
  border-color: #334155;
}

/* Card Padding */
.card-padded {
  padding: 1.5rem;
}

/* Card Hover Effects */
.card-hover:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  border-color: #CBD5E1;
}

.dark .card-hover:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);
  border-color: #475569;
}

/* Card Interactive */
.card-interactive {
  cursor: pointer;
}

.card-interactive:hover {
  box-shadow: 0 20px 25px -5px rgba(37, 99, 235, 0.1);
  border-color: #3B82F6;
  transform: translateY(-2px);
}

.dark .card-interactive:hover {
  box-shadow: 0 20px 25px -5px rgba(56, 189, 248, 0.1);
  border-color: #38BDF8;
}

/* Card Header */
.card-header {
  border-bottom: 1px solid #E2E8F0;
  padding: 1.5rem;
  margin: -1.5rem -1.5rem 1.5rem -1.5rem;
  background-color: #F8FAFC;
}

.dark .card-header {
  border-bottom-color: #334155;
  background-color: #0F172A;
}

.card:not(.card-padded) .card-header {
  margin: 0;
  padding-bottom: 1rem;
}

/* Card Body */
.card-body {
  flex: 1 1;
}

/* Card Footer */
.card-footer {
  border-top: 1px solid #E2E8F0;
  padding: 1.5rem;
  margin: 1.5rem -1.5rem -1.5rem -1.5rem;
  background-color: #F8FAFC;
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}

.dark .card-footer {
  border-top-color: #334155;
  background-color: #0F172A;
}

.card:not(.card-padded) .card-footer {
  margin: 1rem 0 0 0;
  padding-top: 1rem;
}

/* Card Title */
.card-title {
  margin: 0 0 0.5rem 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.5;
}

.dark .card-title {
  color: #F8FAFC;
}

/* Card Subtitle */
.card-subtitle {
  margin: 0;
  font-size: 0.875rem;
  color: #64748B;
  line-height: 1.5;
}

.dark .card-subtitle {
  color: #94A3B8;
}

/* Card Content - no padding */
.card-content {
  display: flex;
  flex-direction: column;
}

/* Card Grid */
.card-grid {
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}

@media (max-width: 768px) {
  .card-grid {
    grid-template-columns: 1fr;
  }
}

/* Card with Image */
.card-image {
  width: 100%;
  height: auto;
  border-radius: 0.5rem;
  overflow: hidden;
  margin-bottom: 1rem;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 200ms ease-in-out;
}

.card-interactive:hover .card-image img {
  transform: scale(1.05);
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/styles/Card.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD,gDAAgD;AAChD,kDAAkD;;AAElD;EACE,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,eAAe;AACjB;;AAEA;EACE,mDAAmD;EACnD,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;EACpD,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;EAChC,eAAe;EACf,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE,SAAO;AACT;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,eAAe;EACf,sCAAsC;EACtC,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,WAAW;EACX,4DAA4D;AAC9D;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* ============================================= */\n/* CARD COMPONENT STYLES - VANTA INSPIRED      */\n/* ============================================= */\n\n.card {\n  background-color: white;\n  border: 1px solid #E2E8F0;\n  border-radius: 0.875rem;\n  overflow: hidden;\n  transition: all 200ms ease-in-out;\n  position: relative;\n}\n\n.dark .card {\n  background-color: #1E293B;\n  border-color: #334155;\n}\n\n/* Card Padding */\n.card-padded {\n  padding: 1.5rem;\n}\n\n/* Card Hover Effects */\n.card-hover:hover {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  border-color: #CBD5E1;\n}\n\n.dark .card-hover:hover {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);\n  border-color: #475569;\n}\n\n/* Card Interactive */\n.card-interactive {\n  cursor: pointer;\n}\n\n.card-interactive:hover {\n  box-shadow: 0 20px 25px -5px rgba(37, 99, 235, 0.1);\n  border-color: #3B82F6;\n  transform: translateY(-2px);\n}\n\n.dark .card-interactive:hover {\n  box-shadow: 0 20px 25px -5px rgba(56, 189, 248, 0.1);\n  border-color: #38BDF8;\n}\n\n/* Card Header */\n.card-header {\n  border-bottom: 1px solid #E2E8F0;\n  padding: 1.5rem;\n  margin: -1.5rem -1.5rem 1.5rem -1.5rem;\n  background-color: #F8FAFC;\n}\n\n.dark .card-header {\n  border-bottom-color: #334155;\n  background-color: #0F172A;\n}\n\n.card:not(.card-padded) .card-header {\n  margin: 0;\n  padding-bottom: 1rem;\n}\n\n/* Card Body */\n.card-body {\n  flex: 1;\n}\n\n/* Card Footer */\n.card-footer {\n  border-top: 1px solid #E2E8F0;\n  padding: 1.5rem;\n  margin: 1.5rem -1.5rem -1.5rem -1.5rem;\n  background-color: #F8FAFC;\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n}\n\n.dark .card-footer {\n  border-top-color: #334155;\n  background-color: #0F172A;\n}\n\n.card:not(.card-padded) .card-footer {\n  margin: 1rem 0 0 0;\n  padding-top: 1rem;\n}\n\n/* Card Title */\n.card-title {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.5;\n}\n\n.dark .card-title {\n  color: #F8FAFC;\n}\n\n/* Card Subtitle */\n.card-subtitle {\n  margin: 0;\n  font-size: 0.875rem;\n  color: #64748B;\n  line-height: 1.5;\n}\n\n.dark .card-subtitle {\n  color: #94A3B8;\n}\n\n/* Card Content - no padding */\n.card-content {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Card Grid */\n.card-grid {\n  display: grid;\n  gap: 1.5rem;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n}\n\n@media (max-width: 768px) {\n  .card-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Card with Image */\n.card-image {\n  width: 100%;\n  height: auto;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  margin-bottom: 1rem;\n}\n\n.card-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 200ms ease-in-out;\n}\n\n.card-interactive:hover .card-image img {\n  transform: scale(1.05);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
